import React from 'react';

function MetricsOverview({ metrics }) {
  const successRate = metrics.messages_sent > 0 
    ? ((metrics.messages_sent / (metrics.messages_sent + metrics.messages_failed)) * 100).toFixed(1)
    : 0;

  return (
    <div className="dashboard-card full-width">
      <h2>Metrics Overview</h2>
      <div className="metric-grid">
        <div className="metric-item">
          <div className="metric-value">{metrics.messages_sent}</div>
          <div className="metric-label">Messages Sent</div>
        </div>
        <div className="metric-item">
          <div className="metric-value">{metrics.messages_failed}</div>
          <div className="metric-label">Messages Failed</div>
        </div>
        <div className="metric-item">
          <div className="metric-value">{(metrics.messages_per_minute_rate || 0)}</div>
          <div className="metric-label">Messages/Minute</div>
        </div>
        <div className="metric-item">
          <div className="metric-value">{metrics.throttle_events}</div>
          <div className="metric-label">Throttle Events</div>
        </div>
        <div className="metric-item">
          <div className="metric-value">{metrics.active_users}</div>
          <div className="metric-label">Active Users</div>
        </div>
        <div className="metric-item">
          <div className="metric-value">{successRate}%</div>
          <div className="metric-label">Success Rate</div>
        </div>
      </div>
    </div>
  );
}

export default MetricsOverview;